import { View } from 'react-native'
import { styled } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      height: 220,
      minWidth: 320,
      backgroundColor: theme.colorContainerFillDefault,
      borderColor: theme.colorNone,
      borderWidth: theme.borderWidthNone,
      borderRadius: theme.borderRadiusNone,
      padding: theme.paddingInsetFourpulse,
    },
  }
})
